import {
  Actions,
  AppArea,
  Subjects,
  UnAssignUserGroupUserDocument,
  UserGroupsDocument,
} from 'src/graphql/generated/graphql';
import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { ActionsColumn } from '@otp/ui';
import { Edit, Remove } from '@otp/icons';
import { DeleteConfirmation } from 'src/components/common/form/delete-confirmation';
import { useNavigate } from 'react-router-dom';
import { Routes } from 'src/components/common/router/constants';
import { UserGroupListItem } from 'src/components/user-groups/list/types';
import { useCan } from 'src/utils/can';

type ActionsFieldProps = {
  userGroup: UserGroupListItem;
  userId: string;
};

const QUERIES_TO_REFETCH = [UserGroupsDocument];

export const ActionsField = ({ userGroup, userId }: ActionsFieldProps) => {
  const { can } = useCan();
  const [unAssignUserMutation] = useMutation(UnAssignUserGroupUserDocument, {
    refetchQueries: QUERIES_TO_REFETCH,
  });

  const navigate = useNavigate();

  const { t } = useTranslation();

  const [isDeleting, setIsDeleting] = useState(false);

  const onDelete = () => {
    unAssignUserMutation({
      variables: {
        userGroupId: userGroup.id,
        userId,
      },
    });
    setIsDeleting(false);
  };

  const onEdit = () => {
    window.location;
    navigate(`${Routes.userGroups.path}/${userGroup.id}`);
  };

  const canDelete = can({
    action: Actions.Unassign,
    subject: Subjects.UserGroups,
    appArea: AppArea.Admin,
  });
  const canEdit = can({
    action: Actions.Write,
    subject: Subjects.UserGroups,
    appArea: AppArea.Admin,
  });

  return (
    <>
      <ActionsColumn
        // @ts-ignore
        icons={[
          canEdit
            ? {
                icon: <Edit />,
                onClick: onEdit,
              }
            : null,
          canDelete
            ? {
                icon: <Remove />,
                onClick: () => setIsDeleting(true),
              }
            : null,
        ].filter(Boolean)}
      />
      <DeleteConfirmation
        objectTitle={userGroup.name}
        objectType={t('common.the-user')}
        open={isDeleting}
        onClose={() => setIsDeleting(false)}
        onConfirm={onDelete}
      />
    </>
  );
};
